module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/runtime.lex-2016-11-28.paginators.json
// module id = 744
// module chunks = 4